import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Actions from 'flow/actions';
import { CTI_HOST_DESCRIPTION } from 'flow/utils/cti-config-utils';
import { getIntegrationHost } from 'flow/utils/is-integration';
import { fromJS } from 'immutable';
import { getSelectedCtiContactByNumberFromIntegration } from 'flow/selectors/cti-integration-selectors';
var initialStateDefault = fromJS({
  integrationContacts: {},
  callLogSent: false,
  targetOrigin: null,
  activeCall: null,
  loggedIn: null,
  tooManyInstances: false,
  integrationConfig: {
    hostImgUrl: null,
    hostDescription: CTI_HOST_DESCRIPTION.DEFAULT,
    defaultButtons: []
  }
});
var getInitialState = function getInitialState() {
  var integrationHost = getIntegrationHost();
  var defaultHostName = integrationHost ? integrationHost : CTI_HOST_DESCRIPTION.DEFAULT;
  return initialStateDefault.setIn(['integrationConfig', 'hostDescription'], defaultHostName);
};
function mapLookupContactToIntegrationContact(lookupContact, contactSource) {
  var typeLabel = lookupContact.typeLabel,
    itemLinkFlow = lookupContact.itemLinkFlow,
    routeUrl = lookupContact.routeUrl,
    itemNameFlow = lookupContact.itemNameFlow,
    otherRoutesFlow = lookupContact.otherRoutesFlow,
    routeFlow = lookupContact.routeFlow,
    numberE164Flow = lookupContact.numberE164Flow,
    nameFlow = lookupContact.nameFlow,
    contactRouteButtons = lookupContact.contactRouteButtons,
    altRouteFlow = lookupContact.altRouteFlow;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, lookupContact.metadata && {
    metadata: lookupContact.metadata
  }), contactSource && {
    contactSource: contactSource
  }), typeLabel && {
    typeLabel: typeLabel
  }), contactRouteButtons && {
    contactRouteButtons: contactRouteButtons
  }), otherRoutesFlow && {
    otherRoutes: otherRoutesFlow
  }), routeUrl && {
    routeUrl: routeUrl
  }), routeFlow && {
    contactRoute: routeFlow
  }), itemLinkFlow && {
    itemLink: itemLinkFlow
  }), itemNameFlow && {
    itemName: itemNameFlow
  }), altRouteFlow && {
    altContactRoute: altRouteFlow
  }), {}, {
    // Contact DTO.
    firstName: nameFlow,
    number: numberE164Flow,
    key: 'contact-000000',
    // Needed to comply with prop-checks.

    isSelected: false
  });
}
var sanitizeUrl = function sanitizeUrl(urlString) {
  try {
    var url = new URL(urlString);
    return url.protocol === 'https:' ? urlString : null;
  } catch (_) {
    return null;
  }
};
export var selectContacts = function selectContacts(state, number, contacts) {
  var selectedCtiContact = getSelectedCtiContactByNumberFromIntegration(state, number);
  var contactRoute = selectedCtiContact ? selectedCtiContact.get('contactRoute') : null;

  // if there is a previously selected contact, we want to find its equal, and make it selected
  var matchingContact = contacts.find(function (contact) {
    return contactRoute === contact.contactRoute;
  });
  if (matchingContact) {
    matchingContact.isSelected = true;
  } else if (contacts.length > 0) {
    // if there was no selected contact for the number, we want select the first contact.
    var firstContact = contacts[0];
    firstContact.isSelected = true;
  }
  return [number, contacts];
};
export var integrationReducer = function integrationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case Actions.CLEAR_STATE:
      {
        return getInitialState();
      }
    case Actions.CTI_USER_LOGGED_OUT:
      {
        return state.set('loggedIn', false);
      }
    case Actions.CTI_USER_LOGGED_IN:
      {
        return state.set('loggedIn', true);
      }
    case Actions.CTI_RESULT_CONTACT_DECORATIONS:
      {
        var contacts = action.data.contacts;
        var contactSource = state.getIn(['integrationConfig', 'hostDescription']);
        return Object.entries(contacts).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            number = _ref2[0],
            contacts = _ref2[1];
          return [number, contacts.map(function (e) {
            return mapLookupContactToIntegrationContact(e, contactSource);
          })];
        }).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            number = _ref4[0],
            contacts = _ref4[1];
          return selectContacts(state, number, contacts);
        }) // sets a selected contact for each number
        .reduce(function (accumulator, _ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            number = _ref6[0],
            contacts = _ref6[1];
          return accumulator.setIn(['integrationContacts', number], fromJS(contacts));
        }, state);
      }
    case Actions.CTI_REGISTER_ORIGIN:
      {
        var targetOrigin = action.targetOrigin,
          data = action.data;
        var _ref7 = data ? data : {},
          host = _ref7.host;
        var _ref8 = host ? host : {},
          imageUrl = _ref8.imageUrl,
          description = _ref8.description,
          defaultButtons = _ref8.defaultButtons,
          ctiHostSetting = _ref8.ctiHostSetting;
        if (ctiHostSetting) {
          state = state.setIn(['integrationConfig', 'ctiHostSetting'], fromJS(ctiHostSetting));
        }
        return state.set('targetOrigin', targetOrigin).setIn(['integrationConfig', 'hostImgUrl'], sanitizeUrl(imageUrl)).setIn(['integrationConfig', 'hostDescription'], description).setIn(['integrationConfig', 'defaultButtons'], fromJS(defaultButtons || []));
      }
    case Actions.CTI_FEATURE_FLAGS:
      {
        var _action$data = action.data,
          creationButtons = _action$data.creationButtons,
          formButtons = _action$data.formButtons;
        var featureButtons = {
          creationButtons: creationButtons,
          formButtons: formButtons
        };
        return state.set('featureButtons', fromJS(featureButtons));
      }
    case Actions.CTI_CALL_LOG_SENT:
      {
        return state.set('callLogSent', true);
      }
    case Actions.CTI_CLEAR_CALL_LOG_SENT:
      {
        return state.set('callLogSent', false);
      }
    case Actions.CTI_SET_TOO_MANY_INSTANCES:
      {
        var tooManyInstances = action.data.tooManyInstances;
        return state.set('tooManyInstances', tooManyInstances);
      }
    case Actions.CTI_SET_SELECTED_CONTACT:
      {
        var number = action.contact.get('number');
        var _contacts = state.getIn(['integrationContacts', number]);
        var newSelectContactIndex = _contacts.findIndex(function (contact) {
          return contact.get('contactRoute') === action.contact.get('contactRoute');
        });

        // toggles isSelected to false for all contacts
        state = state.updateIn(['integrationContacts', number], null, function (contacts) {
          return contacts.map(function (contact) {
            return contact.set('isSelected', false);
          });
        });

        // updates isSelected to true for the new selected contact
        return state.updateIn(['integrationContacts', number, newSelectContactIndex], function (contact) {
          return contact.set('isSelected', true);
        });
      }
    default:
      {
        return state;
      }
  }
};
export default integrationReducer;